import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

export default function PaymentTermsAndConditions() {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <Card>
            <Card.Body>
              <h2 className="mb-4">Payment Terms and Conditions</h2>
              <p>
                By subscribing to any paid plan on this site, you agree to the
                following payment terms and conditions. Please read them
                carefully before completing your purchase.
              </p>
              <h5>1. Subscription & Billing</h5>
              <ul>
                <li>
                  All subscriptions are billed in advance on a recurring basis
                  (monthly or yearly, as selected).
                </li>
                <li>
                  Payments are securely processed by Stripe. We do not store
                  your card details on our servers.
                </li>
                <li>
                  You authorize us to charge your payment method for the
                  subscription amount at each renewal period.
                </li>
              </ul>
              <h5>2. Cancellation & Refunds</h5>
              <ul>
                <li>
                  You may cancel your subscription at any time from your account
                  dashboard.
                </li>
                <li>
                  Upon cancellation, your subscription will remain active until
                  the end of the current billing period. No further charges will
                  be made.
                </li>
                <li>
                  Refunds are not provided for partial billing periods or unused
                  time.
                </li>
              </ul>
              <h5>3. Price Changes</h5>
              <ul>
                <li>
                  We reserve the right to change subscription prices. You will
                  be notified in advance of any price changes and may cancel
                  before the new price takes effect.
                </li>
              </ul>
              <h5>4. Payment Failures</h5>
              <ul>
                <li>
                  If a payment fails, we may suspend or terminate your access to
                  paid features until payment is received.
                </li>
              </ul>
              <h5>5. Contact</h5>
              <ul>
                <li>
                  For any questions about payments or subscriptions, please
                  contact us at{" "}
                  <a href="mailto:support@epcspark.com">support@epcspark.com</a>.
                </li>
              </ul>
              <hr />
              <p>
                For full legal terms, please see our{" "}
                <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  href="/privacypolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
